module.exports = __webpack_public_path__ + "img/57.0508cc56.jpg";